export default __webpack_public_path__ + "f46bfa4c67ef927209b39989ec0498ba.png";